<div class="d-flex flex-column align-items-center" #origin>
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Import and Schedule Candidates for {{exam.examinationName}}</h5>
    <form class="mr-0 d-flex flex-column   align-items-center" (ngSubmit)="uploadFileCandidate(origin)">

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Select File (.xlxs)</label>
        <input type="file" class="form-control file-select" accept=".xlsx " (change)="onFileChange($event)" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Candidates</label>
        <textarea type="number" min="0" class="form-control" [(ngModel)]="uploadFile.candidateList" rows="2"
          [ngModelOptions]="{ standalone: true }"></textarea>
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Batch Start Date Time</label>
        <input type="datetime-local" class="form-control" [(ngModel)]="uploadFile.batchStartDateTime"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Batch End Date Time</label>
        <input type="datetime-local" class="form-control" [(ngModel)]="uploadFile.batchEndDateTime"
          [ngModelOptions]="{ standalone: true }" />
      </div>
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Gap per batch (minutes)</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="uploadFile.gapPerBatch"
          [ngModelOptions]="{ standalone: true }" />
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Count Per Time Slot (Capacity)</label>
        <input type="number" min="0" class="form-control" [(ngModel)]="uploadFile.capacityPerSlot"
          [ngModelOptions]="{ standalone: true }" />
      </div>

      <div class="row col-md-10 mb-3">
        <div class="col-md-5">
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input mr-1" required
                [(ngModel)]="uploadFile.notifyCandidatesByEmail" [ngModelOptions]="{ standalone: true }">
              <label class="custom-control-label" for="customCheck1"> Notify Candidates By Email</label>
            </div>
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit"> Upload Candidate Schedules
      </button>
    </form>

    <div class="d-flex flex-column align-items-start">
      <a href="/assets/templates/CandidateExaminationScheduleTemplate.xlsx" download class="mt-2">
        Download Template</a>
    </div>
  </div>
</div>